import React, { useState, useEffect } from 'react';
import Icon from '../../icons/Icon';
import { DefaultServices } from '../../../constants/DefaultServices';
import Counter from '../../elements/Counter';
import getStats from '../../../services/SpartaService';
import { getDataAsSearchParams } from '../../../helpers/statsHelper';

const StatsWidget = props => {
    const { data, formData } = props;

    const [oldStats, setOldStats] = useState({
        total: 0,
        reviewsCount: 0,
        averageScore: 0,
    });

    const [stats, setStats] = useState({
        total: 0,
        reviewsCount: 0,
        averageScore: 0,
    });

    useEffect(() => {
        getStats(getDataAsSearchParams(formData, data)).then(res => {
            setOldStats({ ...stats });
            setStats({ ...res });
        });
    }, [data, formData]);

    const renderVerticalMode = () => {
        const serviceDescription = DefaultServices.get(data.key)
            ? DefaultServices.get(data.key).get('description')
            : 'investments';

        return (
            <div>
                <div className="app__stats-widget__item margin">
                    <div className="vertical-label">VouchedFor Advisers</div>
                    <div className="vertical-sub-label push-down-10">{serviceDescription}</div>
                    <div className="app__stats-widget__number spaced">
                        <Counter from={oldStats.total} to={stats.total} delay={30} speed={1200} />
                    </div>
                </div>

                <div className="app__stats-widget__item margin">
                    <div className="vertical-label">Average rating</div>
                    <div className="vertical-sub-label push-down-10">
                        from genuine client reviews
                    </div>
                    <div className="app__stats-widget__number padding-right-45">
                        {stats.averageScore.toFixed(1)}
                        <div className="app__stats-widget__icon">
                            <Icon icon="star" style={{ fill: 'gold' }} size="26px" />
                        </div>
                    </div>
                    <div className="vertical-sub-label push-down-10">out of 5 stars</div>
                </div>

                <div className="app__stats-widget__item">
                    <div className="vertical-label">Clients helped</div>
                    <div className="vertical-sub-label push-down-10">
                        who have received advice from these Financial Advisers
                    </div>
                    <div className="vertical-orientation">
                        <div className="app__stats-widget__number spaced full">
                            <Counter
                                from={oldStats.reviewsCount}
                                to={stats.reviewsCount}
                                delay={30}
                                speed={1200}
                            />
                        </div>
                    </div>
                </div>

                <div className="vertical-label__list--mobile">
                    <div className="vertical-label--mobile">Advisers</div>
                    <div className="vertical-label--mobile">out of 5</div>
                    <div className="vertical-label--mobile">reviews</div>
                </div>
            </div>
        );
    };

    const renderHorizontalMode = () => {
        return (
            <div className="app__stats-widget__container">
                <div className="mobile-line">VouchedFor has</div>
                <div className="app__stats-widget__number spaced">
                    <Counter from={oldStats.total} to={stats.total} delay={30} speed={1200} />
                </div>
                <div className="mobile-line">
                    advisers who can help with this, with an average review rating of
                </div>
                <div className="app__stats-widget__number padding-right-45">
                    {props.averageScore}
                    <div className="app__stats-widget__icon">
                        <Icon icon="star" style={{ fill: 'gold' }} size="26px" />
                    </div>
                </div>

                <div className="line">
                    <div className="mobile-line">They've helped</div>
                    <div className="app__stats-widget__number spaced">
                        <Counter
                            from={oldStats.averageScore}
                            to={stats.reviewsCount}
                            delay={30}
                            speed={1200}
                        />
                    </div>
                    <div className="mobile-line">others like you</div>
                </div>
            </div>
        );
    };

    const container = props.isVertical ? renderVerticalMode() : renderHorizontalMode();
    const verticalMode = props.isVertical ? 'vertical-mode' : '';

    return <div className={`app__stats-widget__container ${verticalMode}`}>{container}</div>;
};

export default StatsWidget;
